module.exports = __webpack_public_path__ + "img/plus.355fc290.png";